/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_SubtitleInputs */

const he_home_subtitle = /** @type {(inputs: Home_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעקב היסטוריית מחירים ב-KSP. חפשו מוצר, עקבו אחרי ירידות מחירים וחסכו כסף.`)
};

const en_home_subtitle = /** @type {(inputs: Home_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track KSP price history. Search products, follow price drops, and save money.`)
};

/**
* | output |
* | --- |
* | "Track KSP price history. Search products, follow price drops, and save money." |
*
* @param {Home_SubtitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_subtitle = /** @type {((inputs?: Home_SubtitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_SubtitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_subtitle(inputs)
	return en_home_subtitle(inputs)
});